<script>
// import InputMask from 'primevue/inputmask';
import Utils from '../../common/Utils';

export default {
    props: ['readonly', 'inputClass', 'modelValue', 'mask', 'hideTimeField', 'elem', 'hideTimeFieldName'],
    emits: ['update:modelValue', 'updateHideTimeField'],
    // components: {InputMask},
    data(){
        return{
            v: null,
            hideTime: false
        }
    },
    created() {
        this.refreshValue();
        this.hideTime = this.hideTimeField;
    },
    watch: {
        modelValue(){
            this.refreshValue();
        }
    },
    methods: {
        refreshValue(){
            if(this.hideTime){
                this.v = this.modelValue ? Utils.formatDate(Utils.dateToCurrentTimeZone(this.modelValue)) : null;
            }else{
                this.v = this.modelValue ? Utils.formatDateTime(Utils.dateToCurrentTimeZone(this.modelValue)) : null;
            }
        },
        blurEvent(){
            if(this.v){
                if(this.v.length > 4){
                    let valueSet = false;
                    let hour = 0, minute = 0, day = 0, month = 0, year = 0, second =0;
                    if(this.v.length == 5){
                        //calcola ore
                        let hourS = parseInt(this.v.substr(0,2));
                        let minuteS = parseInt(this.v.substr(3,2));

                        hour = isNaN(hourS) ? 0 : hourS;
                        minute = isNaN(minuteS) ? 0 : minuteS;

                        let now = new Date();
                        day = now.getDate();
                        month = now.getMonth();
                        year = now.getFullYear();

                        valueSet = true;
                        this.hideTime = false;

                    }else if(this.v.length == 10){
                        // calcola solo giorno
                        let dayS = parseInt(this.v.substr(0,2));
                        let monthS = parseInt(this.v.substr(3,2));
                        let yearS = parseInt(this.v.substr(6,4));
                        
                        day = isNaN(dayS) ? 0 : dayS;
                        month = isNaN(monthS) ? 0 : (monthS- 1);
                        year = isNaN(yearS) ? 0 : yearS;
                    
                        hour = 0;
                        minute = 0;

                        valueSet = true;
                        this.hideTime = true;
                    }else if(this.v.length == 16){
                        if(this.v[5] == ' '){

                            let hourS = parseInt(this.v.substr(0,2));
                            let minuteS = parseInt(this.v.substr(3,2));

                            hour = isNaN(hourS) ? 0 : hourS;
                            minute = isNaN(minuteS) ? 0 : minuteS;

                            let dayS = parseInt(this.v.substr(6,2));
                            let monthS = parseInt(this.v.substr(9,2));
                            let yearS = parseInt(this.v.substr(12,4));
                            
                            day = isNaN(dayS) ? 0 : dayS;
                            month = isNaN(monthS) ? 0 : (monthS- 1);
                            year = isNaN(yearS) ? 0 : yearS;

                            valueSet = true;
                            this.hideTime = false;
                        }else if(this.v[10] == ' '){
                            let dayS = parseInt(this.v.substr(0,2));
                            let monthS = parseInt(this.v.substr(3,2));
                            let yearS = parseInt(this.v.substr(6,4));
                            
                            day = isNaN(dayS) ? 0 : dayS;
                            month = isNaN(monthS) ? 0 : (monthS- 1);
                            year = isNaN(yearS) ? 0 : yearS;

                            let hourS = parseInt(this.v.substr(11,2));
                            let minuteS = parseInt(this.v.substr(14,2));

                            hour = isNaN(hourS) ? 0 : hourS;
                            minute = isNaN(minuteS) ? 0 : minuteS;

                            valueSet = true;
                            this.hideTime = false;
                        }
                    }
                    if(valueSet){
                        let d = new Date(year, month, day, hour, minute, second);
                        this.$emit('update:modelValue', Utils.dateToCurrentTimeZone(d));
                        this.$emit('updateHideTimeField', 
                            {
                                hidetime: this.hideTime,
                                elem: this.elem,
                                field: this.hideTimeFieldName
                            });
                        
                    }else{
                        this.v = null;
                        this.$emit('update:modelValue', null);
                        this.$emit('updateHideTimeField', 
                            {
                                hidetime: this.hideTime,
                                elem: this.elem,
                                field: this.hideTimeFieldName
                            });
                    }
                }
                else{
                    this.v = null;
                    this.$emit('update:modelValue', null);
                    this.$emit('updateHideTimeField', 
                        {
                            hidetime: this.hideTime,
                            elem: this.elem,
                            field: this.hideTimeFieldName
                        });
                }

            }

            // if(this.v){
            //     if(this.v.length > 7){
            //         let day = parseInt(this.v.substr(0,2));
            //         let month = parseInt(this.v.substr(2,2)) - 1;
            //         let year = parseInt(this.v.substr(4,4));
            //         let hour = 0;
            //         let minute = 0;
            //         let second = 0;
            //         if(this.v.length > 9){
            //             hour = parseInt(this.v.substr(8,2));

            //             if(this.v.length > 11){
            //                 minute = parseInt(this.v.substr(10,2));

            //                 if(this.v.length == 14){
            //                     second = parseInt(this.v.substr(12,2));
            //                 }
            //             }
            //         }

            //         let d = new Date(year, month, day, hour, minute, second);
            //         this.$emit('update:modelValue', Utils.dateToCurrentTimeZone(d));
            //     }else{
            //         this.v = null;
            //         this.$emit('update:modelValue', null);
            //     }

            // }else{
            //     this.$emit('update:modelValue', null);
            // }

        },
        updateModelValue(event){

            // if(event){
            //     if(event.length == 14){
            //         let day = parseInt(event.substr(0,2));
            //         let month = parseInt(event.substr(2,2)) - 1;
            //         let year = parseInt(event.substr(4,4));
            //         let hour = parseInt(event.substr(8,2));
            //         let minute = parseInt(event.substr(10,2));
            //         let second = parseInt(event.substr(12,2));
            //         let d = new Date(year, month, day, hour, minute, second);
            //         this.$emit('update:modelValue', Utils.dateToCurrentTimeZone(d));
            //     } else {
            //         if(this.mask && this.mask == '99/99/9999' && event.length == 8){
            //             let day = parseInt(event.substr(0,2));
            //             let month = parseInt(event.substr(2,2)) - 1;
            //             let year = parseInt(event.substr(4,4));
            //             let hour = '01';
            //             let minute = '00';
            //             let second = '00';
            //             let d = new Date(year, month, day, hour, minute, second);
            //             this.$emit('update:modelValue', Utils.dateToCurrentTimeZone(d));
            //         }
            //     }
            // }else{
            //     //this.$emit('update:modelValue', null);
            // }
        },
    }
}
</script>

<template>
    <main>
        <InputText 
            v-model="v" 
            @update:modelValue="updateModelValue"
            :mask="mask || '99/99/9999 99:99'"
            :disabled="readonly"
            :unmask="true"
            :autoClear="false"
            :class="inputClass || 'w-full'"
            v-on:blur="blurEvent"
             />
    </main>
</template>